import { Content } from '../../types';

export const tonleSapContent: Content = {
  title: 'אגם טונלה סאפ – פלא טבע בלב קמבודיה',
  imageUrl: 'https://tinyurl.com/tonle-sap-wide',
  introduction: `אגם טונלה סאפ (Tonlé Sap) הינו האגם הגדול ביותר בדרום-מזרח אסיה ואחד מהמאפיינים הגיאוגרפיים החשובים ביותר של קמבודיה. האגם, הממוקם במרכז המדינה, מהווה נדבך משמעותי מבחינה אקולוגית, כלכלית ותרבותית.`,
  sections: [
    {
      title: 'מערכת הידרולוגית ייחודית',
      content: `אגם טונלה סאפ ידוע בזכות שינויי הזרימה הייחודיים שלו לאורך השנה: בעונת הגשמים (יוני עד נובמבר), הנהר, המחבר את האגם לנהר המקונג (Tonlé Sap River), משנה את כיוונו, בעקבות כמויות המים האדירות במקונג והמים זורמים חזרה לאגם ומגדילים את שטחו מ-2,500 קמ"ר לכ-16,000 קמ"ר! בעונה היבשה (נובמבר עד מאי), הזרם חוזר לכיוון נהר המקונג והאגם מצטמצם משמעותית. תופעה ייחודית זו יוצרת בית גידול עשיר במיוחד לדגים ולחיות בר.`,
      type: 'text',
    },
    {
      title: 'מקור חיים לאלפי תושבים',
      content: `סביב האגם חיים כ-1.5 מיליון אנשים, שרובם תלויים בדיג ובחקלאות. כפרים צפים רבים נבנו על האגם ובהם בתי ספר, שווקים ואפילו מקדשים שנבנים על רפסודות או בתים צפים. הדיג באזור זה אחראי לכ-70% מהדגה המתוקה הנצרכת בקמבודיה.`,
      type: 'text',
    },
    {
      title: 'חשיבות אקולוגית',
      content: `האגם הינו חלק משמורה ביוספרית מוגנת על ידי אונסק"ו ונחשב לאחד האזורים הביולוגיים החשובים ביותר בדרום-מזרח אסיה. הוא משמש בית גידול למאות מינים של דגים, ציפורים ובעלי חיים אחרים.`,
      type: 'text',
    },
    {
      title: 'תרבות ומסורת',
      content: [
        'באזור האגם ניתן לבקר בכפרים צפים ייחודיים, כמו:',
        'קמפונג פלוק (Kampong Phluk)',
        'קמפונג קלהונג (Kampong Khleang)',
        "צ'ונג קניאס (Chong Khneas)",
        'הכפרים מציעים הצצה מרתקת לאורח חיים המסתמך על המים ומשתנה בהתאם לעונות השנה.',
      ],
      type: 'list',
    },
    {
      title: 'מתי מומלץ לבקר?',
      content: [
        'עונת הגשמים (יוני - נובמבר), מומלצת ע"מ לראות את האגם במלוא תפארתו.',
        'בעונה היבשה (נובמבר - מאי), אמנם שטחי המים מצומצמים יותר, אך הכפרים הצפים עדיין מספקים חוויה מרתקת.',
      ],
      type: 'list',
    },
    {
      title: 'טיפים לביקור באגם טונלה סאפ',
      content: [
        'מומלץ לצאת לשייט בכפרים הצפים עם מדריך מקומי שיסביר על החיים באזור.',
        'האגם ממוקם במרחק נסיעה קצרה מסיאם ריפ, כך שניתן לשלב את הביקור בו כחלק מביקור בעיר.',
      ],
      type: 'list',
    },
    {
      title: 'בשורה התחתונה',
      content: `אגם טונלה סאפ הינו תופעת טבע ייחודית בלב קמבודיה והביקור בו מאפשר לצפות, הן בתופעת הטבע המדוברת (בהתאם לעונות השנה כמובן) והן באורח חייהם הייחודי ביותר של תושבי הכפרים הצפים שסביבות האגם.`,
      type: 'text',
    },
  ],
};
